import React, { Component } from 'react';
import _ from 'lodash';
import StoryAnnouncement from './StoryAnnouncement.js';
import FamilyStory from './FamilyStory';
import { connect } from 'react-redux';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import shared from '../../../utils/shared.js';
import NewarkDonorListsPassive from '../../Theme/Newark/NewarkDonorListsPassive';

class AttractLoopContainer extends Component {
  constructor(props) {
    super(props);
    this._background = null;
    this._keys = [];
    this.state = {
      story: null,
      ref: null,
      background: null,
      randomStr: null,
      modules: []
    }
  }
  
  componentDidMount() {
    this.setupModules();
  }

  setupModules = () => {
    let background = "white";
    let modules = this.props.tree.children.map((mod, i) => {
      this._keys[i] = mod.id;
      const nodeType = mod.node_type;
      let type;
      switch(nodeType) {
        case "folder":
          type = _.get(mod, 'contents.custom_fields.folder_type.val.value', null);
          switch(type) {
            case 'donor_lists_hv':
              background = null;
              return this.setupDonorListsHV(mod);
            default:
              return {}
          }
        case "story":
          type = _.get(mod, 'contents.custom_fields.story_type.val.value', null);
          switch(type) {
            case 'baby_announcement':
              return this.setupBabyAnnouncement(mod);
            case 'family_story':
              return this.setupFamilyStory(mod);
            default:
              return {}
          }
        default:
          return {}
      }
    });

    this.setState({
      modules: modules,
      background
    });
  }

  setupDonorListsHV = (module) => {
    let customFields = _.get(module, "contents.custom_fields", {});
    let slideshows = [];
    let otherModules = [];
    for (let field in customFields) {
      if (customFields[field].type === "module" && customFields[field].module === "slideshow") {
        let id = _.get(customFields[field], 'val.value', null);
        if (id) {
          slideshows = _.filter(this.props.content.dm_active, { id: id, display_module_type: "Slideshow" });
        }
      }
    }
    otherModules = otherModules.concat(slideshows);
    return { otherModules: otherModules, folder: module, modal: false, screen: this.props.screen, background: null, type: "donor_lists_hv", node_type: "folder" }
  }

  setupBabyAnnouncement = (module) => {
    let customFields = _.get(module, "contents.custom_fields", {});
    let backgroundObj = _.get(module, "contents.images[0]", null);
    let backgroundImg = this.getBackground(backgroundObj);
    let otherModules = [];
    let slideshows = [];

    for (let field in customFields) {
      if (customFields[field].type === "module" && customFields[field].module === "slideshow") {
        let id = _.get(customFields[field], 'val.value', null);
        if (id) {
          slideshows = _.filter(this.props.content.dm_active, { id: id, display_module_type: "Slideshow" });
        }
      }
    }

    otherModules = otherModules.concat(slideshows);
    return { otherModules: otherModules, story: module, modal: false, screen: this.props.screen, background: backgroundImg, type:"baby_announcement", node_type: "story" }
  }

  setupFamilyStory = (module) => {
    let backgroundObj = _.get(module, "contents.images[0]", null);
    let backgroundImg = this.getBackground(backgroundObj);
    return { story: module, screen: this.props.screen, background: backgroundImg, type:"family_story", node_type: "story" }
  }

  getRenderedModules = () => {
    let renderedModules = this.state.modules.map((mod, i) => {
      switch(mod.node_type) {
        case "story":
          switch(mod.type) {
            case 'baby_announcement':
              return (<StoryAnnouncement key={i} { ...mod }/>);
            case 'family_story':
              return (<FamilyStory key={i} { ...mod }/>);
            default:
              return (<span/>);
          }
        case "folder":
          switch(mod.type) {
            case 'donor_lists_hv':
              return (<NewarkDonorListsPassive key={i} { ...mod }/>);
            default:
              return (<span/>);
          }
        default:
          return (<span/>);

      }
    });

    return renderedModules;
  }
  
  getBackground = (displayImage) => {
    if (displayImage) {
      return shared.dp(this.props.screen, displayImage, null);
    }
    return null;
  }

  render() {
    let renderedModules = this.getRenderedModules();
    return(
      <div style={{ position:"absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, backgroundColor: this.state.background }}>
        <CSSTransitionGroup
          transitionName='fastfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
            <div key={this._keys[this.props.attractLoopRef]} style={{ position:"absolute", width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }}>
              {
                renderedModules[this.props.attractLoopRef]
              }
            </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    screen: state.screen,
  };
}

export default connect(mapStateToProps, null)(AttractLoopContainer);


// WEBPACK FOOTER //
// ./src/Components/Theme/Chicago/AttractLoopContainer.js